import Link from "next/link";
import React from "react";
import { ReporterInfoNavigationItemProps } from "@/types/layout";
import { useRouter } from "next-translate-routes";

export const ReporterInfoNavItem: React.FC<ReporterInfoNavigationItemProps> = ({ navigationItem }) => {
  const router = useRouter();

  const currentRoute = () => {
    if (router.asPath === navigationItem.url) {
      return "bg-gray-100";
    }
    return;
  };
  return (
    <>
      <li>
        <Link
          href={navigationItem.url}
          className={`${currentRoute()} flex items-center justify-between px-5 py-3 transition-colors ease-in-out hover:bg-gray-100 dark:hover:bg-white-25`}
        >
          <span className="font-condensed text-md font-light dark:text-white">{navigationItem.title}</span>
        </Link>
      </li>
    </>
  );
};
